/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Secure_Title6Inputs */

const en_svc_ai_app_rescue_secure_title6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security review`)
};

const ar_svc_ai_app_rescue_secure_title6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مراجعة أمنية`)
};

const bn_svc_ai_app_rescue_secure_title6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিরাপত্তা পর্যালোচনা`)
};

const de_svc_ai_app_rescue_secure_title6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheitsprüfung`)
};

const es_svc_ai_app_rescue_secure_title6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisión de seguridad`)
};

const fr_svc_ai_app_rescue_secure_title6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revue de sécurité`)
};

const pt_svc_ai_app_rescue_secure_title6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisão de segurança`)
};

const zh_svc_ai_app_rescue_secure_title6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全审查`)
};

const tr_svc_ai_app_rescue_secure_title6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güvenlik incelemesi`)
};

const ru_svc_ai_app_rescue_secure_title6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка безопасности`)
};

const pl_svc_ai_app_rescue_secure_title6 = /** @type {(inputs: Svc_Ai_App_Rescue_Secure_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd bezpieczeństwa`)
};

/**
* | output |
* | --- |
* | "Security review" |
*
* @param {Svc_Ai_App_Rescue_Secure_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_secure_title6 = /** @type {((inputs?: Svc_Ai_App_Rescue_Secure_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Secure_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_secure_title6(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_secure_title6(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_secure_title6(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_secure_title6(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_secure_title6(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_secure_title6(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_secure_title6(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_secure_title6(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_secure_title6(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_secure_title6(inputs)
	return en_svc_ai_app_rescue_secure_title6(inputs)
});
export { svc_ai_app_rescue_secure_title6 as "svc_ai-app-rescue_SECURE_title" }